/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ThemeProvider, useMediaQuery } from "@mui/material";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import "leaflet/dist/leaflet.css";

import "./App.css";
import Root from "./routes";
import { createAppTheme } from "./theme/muiThemes";
import React, { useEffect, useMemo } from "react";
import { AppWrapper, useUserSettings } from "./contexts/useStorageContext";

const AppInner = () => {
  const { userSettings } = useUserSettings();
  const prefersDark = useMediaQuery("(prefers-color-scheme: dark)");

  const resolvedMode: "light" | "dark" = useMemo(() => {
    const saved = userSettings?.themeMode;
    if (saved === "dark") return "dark";
    if (saved === "light") return "light";
    return prefersDark ? "dark" : "light";
  }, [userSettings?.themeMode, prefersDark]);

  const theme = useMemo(
    () => createAppTheme(resolvedMode, userSettings),
    [resolvedMode, userSettings]
  );

  useEffect(() => {
    document.body.setAttribute("data-theme-mode", resolvedMode);
    document.documentElement.style.colorScheme = resolvedMode;
  }, [resolvedMode]);

  return (
    <>
      <ReactNotifications />
      <ThemeProvider theme={theme}>
        <Root />
      </ThemeProvider>
    </>
  );
};

function App() {
  return (
    <AppWrapper>
      <AppInner />
    </AppWrapper>
  );
}

export default App;
